/**
 * @generated SignedSource<<dc14884aab6f4f8ee162a9d98b78c291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicsMenuItemQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly __typename: "Topic";
    readonly name: string;
    readonly urlAlias: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "topicsMenuItemQueueItemsEdge";
}>;
export type topicsMenuItemQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: topicsMenuItemQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicsMenuItemQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topicsMenuItemQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlAlias",
              "storageKey": null
            }
          ],
          "type": "Topic",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "96c7cb1ccf49bfb086f793e2163c4c67";

export default node;
